import createModalContext from 'app/components/utilities/createModalContext';
import { createParamContext, makeBooleanParser } from 'app/components/router/createParamContext';
import { QueryParameter } from 'app/constants/QueryParameter';
import React, { FunctionComponent, useEffect } from 'react';
import { useHistory } from 'app/components/router/History';

const {
  ModalProvider,
  GetModalControl: GetReportProblemModalControl,
  IsModalOpen:     IsReportProblemModalOpen,
} = createModalContext();

export {
  GetReportProblemModalControl,
  IsReportProblemModalOpen,
};

export const {
  useParams: useForceShowReportButton,
  Provider: ForceShowReportButtonQueryProvider,
} = createParamContext(makeBooleanParser(QueryParameter.ForceShowReportButton, false));

export const ReportProblemModalProvider: FunctionComponent = ({ children }) => {
  const history = useHistory();

  useEffect(() => {
    const release = history.preserveParams(QueryParameter.ForceShowReportButton);
    return release;
  }, [history]);

  return (
    <ModalProvider>
      <ForceShowReportButtonQueryProvider>
        {children}
      </ForceShowReportButtonQueryProvider>
    </ModalProvider>
  );
};
